import React, { useEffect, useState } from "react";
import { Card, CardContent, CircularProgress, Typography } from "@mui/material";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import { getTopCustomers } from "../../../Services/DashboardService";

// Register required Chart.js components
Chart.register(ArcElement, Tooltip, Legend);
// Define component props
interface TopCustomersPieChartProps {
  orgId: string;
}
const TopCustomersPieChart: React.FC<TopCustomersPieChartProps> = ({ orgId }) => {
  const [chartData, setChartData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!orgId) {
      setError("Organization ID is missing");
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const customers = await getTopCustomers(orgId);

        // Extract labels and sales amounts
        const labels = customers.map((customer: any) => customer.customerName);
        const dataValues = customers.map((customer: any) => customer.totalAmount);

        // Update Chart Data
        setChartData({
          labels,
          datasets: [
            {
              label: "Sales Amount",
              data: dataValues,
              backgroundColor: ["#4caf50", "#ff9800", "#03a9f4", "#e91e63", "#9c27b0"],
              borderColor: "#ffffff",
              borderWidth: 2,
            },
          ],
        });

        setLoading(false);
      } catch (err: any) {
        setError(err.message || "Error fetching data");
        setLoading(false);
      }
    };

    fetchData();
  }, [orgId]); // Runs when orgId changes

   const data = {
    labels: ["John Doe", "Jane Smith", "Acme Corp", "Tech Innovators", "XYZ Ltd"],
    datasets: [
      {
        label: "Sales Amount",
        data: [4500, 3500, 2800, 2200, 1800],
        backgroundColor: ["#4caf50", "#ff9800", "#03a9f4", "#e91e63", "#9c27b0"],
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };

  // Pie Chart Options
 // Pie Chart Options
 const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom" as const,
    },
    tooltip: {
      callbacks: {
        label: function (tooltipItem: any) {
          return `${tooltipItem.label}: ₹${tooltipItem.raw.toLocaleString()}`;
        },
      },
    },
  },
};
  return (
    // <Card sx={{ borderRadius: 1, padding: 2 }}>
    //   <CardContent>
    //     <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center" }}>
    //       Top Customers by Sales
    //     </Typography>
    //     <Pie data={data} options={options} />
    //   </CardContent>
    // </Card>
    <Card sx={{ borderRadius: 1, padding: 2 }}>
    <CardContent>
      <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center" }}>
        Top Customers by Sales
      </Typography>
      {loading ? (
        <CircularProgress sx={{ display: "block", margin: "20px auto" }} />
      ) : error ? (
        <Typography color="error" sx={{ textAlign: "center" }}>{error}</Typography>
      ) : (
        <Pie data={chartData} options={options} />
      )}
    </CardContent>
  </Card>
  );
};

export default TopCustomersPieChart;
